import React from 'react'
import './NotFound.css'


const NotFound = () => {
    return (
        <>
            <div className='not-found-container'>
                <div className='not-found-bg'>404</div>
                <div className='not-found-content'>
                    <h1 className="not-found-heading">Uh Oh, This Page Got Lost!</h1>
                    <p className="not-found-para">It looks like the page you were looking for doesn't exist anymore. Don't worry, it happens to the best of us.</p>
                </div>
            </div>

        </>
    )
}

export default NotFound